module.exports = __webpack_public_path__ + "img/p3-left.9f63263e.svg";